import mitt from "mitt";
import MindMap from "simple-mind-map";
// @ts-ignore
import RainbowLines from "simple-mind-map/src/plugins/RainbowLines.js";
// @ts-ignore

// @ts-ignore
import Export from "simple-mind-map/src/plugins/Export.js";
// @ts-ignore
import { ExcalidrawMindmapElement, FontString } from "./types";
import { mutateElement } from "./mutateElement";
import addIcon from "../assets/add.svg";
import addIconWhite from "../assets/add_white.svg";
import NodeImgAdjust from "../components/MindMap/NodeImgAdjust/NodeImgAdjust.js";
// import RichText from "simple-mind-map/src/plugins/RichText.js";
import RichText from "../components/MindMap/Plus/RichText.js";
// import Drag from "simple-mind-map/src/plugins/Drag.js";
import Select from "./mindMapSelect";
// import Drag from "../components/MindMap/Plus/Drag.js"
import { wrapText } from "./textElement";
import { normalizeLink } from "../data/url";
import {
  EVENT_FORCE_UPDATE_MINDMAP,
  EVENT_MINDMAP_ADD_CARD,
  EVENT_MINDMAP_PREVIEW_ATTACH, EVENT_MINDMAP_REMOVE_ATTACH, EVENT_NOTE_ON_SLIDER_RIGHT, EVENT_PDF_ON_SLIDER_RIGHT,
  getMindmapRootTextColor,
  getMindmapSecondTextColor, KEY_FILE_DIR, KEY_MINDMAP_STYLE_CONFIG
} from "../../../../src/Const";
import {
  checkIfAbsolute,
  getBase64ImageSize,
  getFileName, getLocalFilePath,
  isDarkMode,
  noteToPng,
  recursionMindmapData
} from "../../../../src/utils";
import global from "../../../../src/global";
import {postMessage} from "../../../../src/common/event";
import {ipcInvoke} from "../../../../src/common/ipc";
import {getImageSize} from "simple-mind-map/types/src/utils";
import {getImageFileSize} from "../data/image";
import { AppState } from "../types";
import i18next, {t} from "i18next";
import {APP_WEB, isWebApp} from "../../../../src/electron_interactive";
import {getShareFileUrl} from "../../../../src/api/Aws";
import {updateMindmapLinkIcon} from "../../../../src/Utility0";
// @ts-ignore
import Global from "../../../../src/global";
import {createBreadcrumb} from "../../../../src/Utility";
import Drag from "./mindMapDrag";
import {isMindmapElement} from "./typeChecks";



export type EmitterEvents = {
  node_active: any;
  imagePreview: any;
};
export const emitter = mitt<EmitterEvents>();

export const mindMapCache: Map<string, MindMap> = new Map();
export const mindMapPngCache: Map<string, HTMLCanvasElement> = new Map();
//初始化时mindmap元素的ID对应的mindmap的data-----
export const mindMapId_Data:Map<string,object> = new Map<string, object>();
export const mindMapUid_Text:Map<string,Object> = new Map<string, Object>();
export let beforeActiveNode: any = null;
export let activeNode: any = null;
export let beforeLeftNodeElement: any = null;
export let beforeRightNodeElement: any = null;
export let beforeBottomNodeElement: any = null;
export let g_isEditMindmap:boolean = false;
export let g_isEnterMindmap = false;//是否按enter进入了mindmap的编辑
const mapMindResizeCount:any = {};
let isBlankAreaDrag = false;

//mindmap的回调
let mMindmapcallback:any;
let mLayout:any;

const addPlugin = MindMap.usePlugin;
if (APP_WEB){
  addPlugin(RainbowLines)
      .usePlugin(Export)
      .usePlugin(NodeImgAdjust)
      .usePlugin(RichText);
}else{
  addPlugin(RainbowLines)
      .usePlugin(Drag)
      .usePlugin(Export)
      .usePlugin(NodeImgAdjust)
      .usePlugin(RichText)
      .usePlugin(Select);
}



// 字体列表
export const fontFamilyList = [
  {
    label: "微软雅黑",
    key: "微软雅黑, Microsoft YaHei",
  },
  {
    label: "楷体",
    key: "楷体, 楷体_GB2312, SimKai, STKaiti",
  },
  {
    label: "Andale Mono",
    key: "andale mono",
  },
  {
    label: "Arial",
    key: "arial, helvetica, sans-serif",
  },
  {
    label: "arialBlack",
    key: "arial black, avant garde",
  },
];

// 字号
export const fontSizeList = [10, 12, 14, 16, 18];
// 线宽
export const lineWidthList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
// 连线风格
export const lineStyleList = [
  {
    label: "Straight",
    key: "straight",
  },
  {
    label: "Curve",
    key: "curve",
  },
  {
    label: "Direct",
    key: "direct",
  },
];

export const OFFSET = 20;

let observeEditor = false;

let isDragging = false;
let mousedownedNode: any = null;
let elMousedown = false;
let startX = 0;
let startY = 0;
let startTime = 0;
let mousedownedElementId: string | null = null;
let mapElements:any = {};
const scaleRegex = /scale\(([^)]+)\)/;

export const copy: any = {};
export let mindMapFormatInfo: any = {};
let mCurrentMindmapData:any = null;

/**
 * id:generateUUID2(),
 *                     type:'pdf',
 *                     fileName:res,
 *                     showName:getFileNameWithoutExt(res),
 *                     isSingle:true
 */

/**
 * 设置mindmap的模式
 * @param szMode
 */
export const updateMindmapMode = (szMode:string|'readonly'|'edit')=>{
  mindMapCache.forEach((value, key, map)=>{
    // value.setMode(szMode);
    value.updateConfig({
      enableFreeDrag:szMode == 'edit',
    })
  })
}

export const clearMindmapActiveNode = ()=>{
  if (beforeActiveNode){
    if (beforeActiveNode.renderer.textEdit.isShowTextEdit()){
      beforeActiveNode.renderer.textEdit.hideEditTextBox();
    }

    beforeActiveNode.renderer.clearActiveNode();
  }
  activeNode = null;
  Global.g_currentSelectMindmap = null;
  hiddenToolbar();
}

export const clearMindmapActiveNodeAll = ()=>{
  mindMapCache.forEach((value, key, map)=>{
    value.renderer.clearActiveNode();
  });
  hiddenToolbar()
}

export const hideMindmapEditBox = ()=>{
  if (beforeActiveNode){
    beforeActiveNode.renderer.textEdit.hideEditTextBox();
  }
}

export const getAllMindmapPdfFiles = ()=>{
  var arrayPdfFiles:any = [];
  mindMapCache.forEach((value, key, map)=>{
    var root = value.getData('root').root;

    traverseMap(root,0,async (node)=>{
      const extra = node.data?.extra;
      if (extra){
        if (extra.type == 'pdf'){
          arrayPdfFiles.push(extra)
        }
      }
    });
  });
  return arrayPdfFiles;
}

/**
 * 更新mindmap的笔记缓存图片
 * @param noteData
 */
export const updateMindmapNoteImgCache = (noteData:any)=>{
  mindMapCache.forEach((value, key, map)=>{
    // var root = value.getData('root').root;
    // traverseMap(root,0,async (node)=>{
    //   const extra = node.data?.extra;
    //   if (extra){
    //     if (extra.type == 'card' && extra.id == noteData.id){
    //       node.setImage(await noteToPng(null,noteData.name,noteData.doc));
    //       // value.reRender(()=>{
    //       //
    //       // });
    //     }
    //   }
    // });

    const rootNode = value.renderer.root;
    // console.log(rootNode);
    recursionRoot(rootNode,async (node:any)=>{
      if (node){
        const extra = node.getData()?.extra;
        if (extra){
          if (extra.type == 'card' && extra.id == noteData.id){
            noteToPng(null,noteData.name,noteData.doc).then(async (szBase64)=>{
              const size = await getBase64ImageSize(szBase64);
              const scale = 100 / size?.width;
              node.setImage({
                url: szBase64,
                title: noteData.name,
                width: 100, // 图片的宽高也不能少
                height: scale * size?.height,
              });
            });
          }
        }
      }
    })
  })
}

export function recursionRoot(node:any,callback:any){
  callback(node);
  if (node && node.children){
    node.children.forEach(function (child:any){
      recursionRoot(child,callback)
    })
  }
}

function traverseMap(node, level,callback) {
  level = level || 0;
  var spacing = new Array(level + 1).join('  ');
  console.log(spacing + node.text);
  callback(node);

  if (node.children) {
    node.children.forEach(function(child) {
      traverseMap(child, level + 1,callback);
    });
  }
}

export const reRenderMindmap = ()=>{
  mindMapCache.forEach((value, key, map)=>{
    value.reRender(()=>{

    });
  })
}


export const resetMindmapCache = ()=>{
  mindMapCache.clear();
  document.body.removeEventListener('mousedown',mouseDown)
}

function setPresentMode(){
  mindMapCache.forEach((value, key, map)=>{
    value.renderer.textEdit.hideEditTextBox();
  })
}

export function updateMindmapCallback (callback:any){
  mMindmapcallback = callback;
}



export function mindMapControls(zoom: any, node: any, mindMap: MindMap) {
  addMindMapControls(node, mindMap, addIcon, OFFSET, zoom);
}
export const renderNodesToolBar = (nodes: any[], id: string) => {
  setTimeout(() => {
    const nLength = mindMapCache.get(id)?.renderer?.activeNodeList?.length;
    if (nLength == 0)return;

    let left = Infinity;
    let top = Infinity;
    nodes.forEach((node) => {
      if (!node) {
        return;
      }
      const {
        shapeNode: { node: nodeDom },
      } = node;
      const rect = nodeDom.getBoundingClientRect();

      if (rect.left < left) {
        left = rect.left;
      }
      if (rect.top < top) {
        top = rect.top;
      }
    });
    const isNotInserting: any[] = [];
    nodes.forEach((item) => {
      if (item.__isInserting) {
        delete item.__isInserting;
        return;
      }
      isNotInserting.push(item);
    });
    if (isNotInserting.length) {
      const toolbar = document.getElementById(
          `excalidraw__mindmap__outer__toolbar`,
      )!;
      toolbar.style.display = "block";
      toolbar.style.left = `${left - 30}px`;
      toolbar.style.top = `${top - 50}px`;
      const hasRootNode = !!nodes.some((node) => node.isRoot);
      mindMapFormatInfo = { id, isNodes: true, hasRootNode };
    }else{
      hiddenToolbar();
    }
  }, 100);
};

/**
 * 更新toolbar的位置，拖动根节点的时候.
 */
const updateNodesToolbarPosition = (mindMap)=>{
  // const node = null;
  // if(mindMap.renderer.activeNodeList.length > 0){
  //
  // }
  if (!activeNode?.node?.isRoot)return;
  let left = Infinity;
  let top = Infinity;
  const {
    shapeNode: { node: nodeDom },
  } = activeNode?.node;
  const rect = nodeDom.getBoundingClientRect();

  if (rect.left < left) {
    left = rect.left;
  }
  if (rect.top < top) {
    top = rect.top;
  }

  const toolbar = document.getElementById(
      `excalidraw__mindmap__outer__toolbar`,
  )!;
  toolbar.style.display = "block";
  toolbar.style.left = `${left - 30}px`;
  toolbar.style.top = `${top - 50}px`;
}

const pointerNoneThis = (mindMap)=>{
  if (!activeNode?.node?.isRoot)return;
  const dom = document.getElementById(
      `excalidraw__mindmap__outer${mindMap.element.id}`,
  )!;
  if (dom){
    //todo 这里，设置为all时   有拖动的元素经过mindmap时，会卡顿。*****  同app.tsx中的一个设置 搜索相同的注释...
    dom.style.pointerEvents = "none";
  }
}

const deleteMindMapControls = () => {
  if (beforeRightNodeElement) {
    // beforeRightNodeElement.style.display = "none";
    beforeRightNodeElement.remove();
  }
  if (beforeBottomNodeElement) {
    // beforeBottomNodeElement.style.display = "none";
    beforeBottomNodeElement.remove();
  }
  if (beforeLeftNodeElement) {
    beforeLeftNodeElement.remove();
  }
};

/**
 * 隐藏工具栏
 */
export const hiddenToolbar = ()=>{
  const actElement = document.activeElement;
  if (actElement && actElement.id == 'input-choose-font-size'){
    //是文本框输入的字体大小，不要隐藏
    console.log('document.activeElement.id=input-choose-font-')
    return;
  }
  const toolbar = document.getElementById(
      `excalidraw__mindmap__outer__toolbar`,
  )!;
  if (toolbar){
    toolbar.style.display = "none";
  }

}

export const addMindMapControls = (
    node: {
      dir?: string;
      group: { node: any };
      getRectInSvg: () => any;
      isRoot: any;
    },
    mindMap: any,
    addIcon: string,
    OFFSET: number,
    zoom: number,
) => {
  if (global.g_isPresentMode)return;

  mindMap.view.setScale(zoom);
  // Sync scale only when it actually changes. Calling setScale() on each node
  // selection can trigger internal reflows and cause visible jitter.
  try {
    const prevZoom = (mindMap as any).__excalidrawZoom;
    if (typeof prevZoom !== "number" || Math.abs(prevZoom - zoom) > 1e-4) {
      // @ts-ignore
      mindMap.view.setScale(zoom);
      (mindMap as any).__excalidrawZoom = zoom;
    }
  } catch {}
  const layout = mindMap.getLayout();
  // 隐藏之前的节点元素
  deleteMindMapControls();

  if (!node) {
    return;
  }

  // console.log('****!node******')

  const nodeElement = node.group.node;
  const rectangle = node.getRectInSvg();

  const width = rectangle.width / zoom;
  const height = rectangle.height / zoom;

  // 创建右侧的添加图标
  const rightImage = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "image",
  );
  rightImage.setAttributeNS("http://www.w3.org/1999/xlink", "href", isDarkMode()?addIconWhite:addIcon);
  rightImage.setAttribute("x", `${width + OFFSET}`);
  rightImage.setAttribute("y", `${height / 2 - OFFSET / 2}`);
  rightImage.setAttribute("width", "20");
  rightImage.setAttribute("height", "20");
  rightImage.style.cursor = "pointer";
  rightImage.classList.add('mindmap-add-node')
  rightImage.onclick = () => {
    // Clear the selection-only render flag so node_tree_render_end performs
    // a full resize after the new node is inserted.
    (mindMap as any).__excalidrawNodeSelectRender = false;
    clearTimeout((mindMap as any).__excalidrawNodeSelectRenderTimer);
    // 右布局，左右布局增加子节点
    if (["logicalStructure", "mindMap"].includes(layout)) {
      mindMap.execCommand("INSERT_CHILD_NODE");
      return;
    }
    if (layout === "organizationStructure") {
      // 下布局
      mindMap.execCommand("INSERT_NODE");
      hiddenToolbar();
    }
  };
  beforeRightNodeElement = rightImage;

  // 创建底部的添加图标
  const bottomImage = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "image",
  );
  bottomImage.setAttributeNS("http://www.w3.org/1999/xlink", "href", isDarkMode()?addIconWhite:addIcon);
  bottomImage.setAttribute("x", `${width / 2 - OFFSET / 2}`);
  bottomImage.setAttribute("y", `${height + OFFSET / 2}`);
  bottomImage.setAttribute("width", "20");
  bottomImage.setAttribute("height", "20");
  bottomImage.style.cursor = "pointer";
  bottomImage.style.pointerEvents = "all";
  bottomImage.classList.add('mindmap-add-node')
  bottomImage.onclick = () => {
    (mindMap as any).__excalidrawNodeSelectRender = false;
    clearTimeout((mindMap as any).__excalidrawNodeSelectRenderTimer);
    if (["logicalStructure", "mindMap"].includes(layout)) {
      mindMap.execCommand("INSERT_NODE");
      return;
    }
    mindMap.execCommand("INSERT_CHILD_NODE");
    hiddenToolbar();
  };
  bottomImage.style.opacity = '0';

  beforeBottomNodeElement = bottomImage;

  // 创建左侧的添加图标
  const leftImage = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "image",
  );
  leftImage.setAttributeNS("http://www.w3.org/1999/xlink", "href", addIcon);
  leftImage.setAttribute("x", `${-OFFSET * 2}`);
  leftImage.setAttribute("y", `${height / 2 - OFFSET / 2}`);
  leftImage.setAttribute("width", "20");
  leftImage.setAttribute("height", "20");
  leftImage.classList.add('mindmap-add-node')
  leftImage.style.cursor = "pointer";
  leftImage.onclick = () => {
    (mindMap as any).__excalidrawNodeSelectRender = false;
    clearTimeout((mindMap as any).__excalidrawNodeSelectRenderTimer);
    mindMap.execCommand("INSERT_CHILD_NODE");
  };
  beforeLeftNodeElement = leftImage;

  // 如果是根节点
  if (node.isRoot) {
    // 如果是下布局
    if (layout === "organizationStructure") {
      nodeElement.appendChild(bottomImage);
      return;
    }
    nodeElement.appendChild(rightImage);
    if (layout === "mindMap") {
      nodeElement.appendChild(leftImage);
    }
    return;
  }

  // 不是根节点
  nodeElement.appendChild(bottomImage);
  if (layout === "organizationStructure") {
    nodeElement.appendChild(rightImage);
    return;
  }
  if (layout === "logicalStructure") {
    nodeElement.appendChild(rightImage);
    return;
  }
  const direction = node.dir;
  if (direction === "left") {
    nodeElement.appendChild(leftImage);
    return;
  }
  if (direction === "right") {
    nodeElement.appendChild(rightImage);
  }
};

function mouseDown(e){
  let isInclude = false;
  e.target?.classList?.forEach(p=>{
    if (p == 'iskeeptoopbar'){
      isInclude = true;
    }
  })
  if (
      // @ts-ignore
      ["toolbar"].includes(e.target?.className) ||
      isInclude ||
      // @ts-ignore
      (e.target.className?.includes && e.target.className?.includes("ant")) ||
      global.g_isFontSelectedOpend ||
      global.g_isKeepMindmapToolbarShow
  ) {
    return;
  }

  //todo 20250508
  // if (!elMousedown && mousedownedElementId) {
  //   const currentMindmap = mindMapCache.get(mousedownedElementId)!;
  //   if (currentMindmap) {
  //     const activeNodes = activeNode?.node;
  //     const currentEditNode =
  //         currentMindmap.renderer.textEdit.getCurrentEditNode();
  //     if (currentEditNode) {
  //       currentMindmap.renderer.textEdit.hideEditTextBox();
  //       setTimeout(() => {
  //         currentMindmap.keyCommand.pause();
  //       }, 0);
  //     }
  //     activeNodes?.deactivate();
  //   }
  // }
  // elMousedown = false;

  let bClear = false;
  if (!elMousedown && mousedownedElementId) {
    const currentMindmap = mindMapCache.get(mousedownedElementId)!;
    if (currentMindmap) {
      const activeNodes = activeNode?.node;
      const currentEditNode =
          currentMindmap.renderer.textEdit.getCurrentEditNode();
      if (currentEditNode) {
        // currentMindmap.renderer.textEdit.hideEditTextBox();
      }
      // activeNodes?.deactivate();
      currentMindmap.renderer.clearActiveNode();
      bClear = true;
    }
  }

  if (!elMousedown && !bClear){
    clearMindmapActiveNodeAll();
  }


  elMousedown = false;

  // @ts-ignore
  if (e.target?.className === "excalidraw__canvas interactive" || e.target?.tagName == 'svg') {
    // const toolbar = document.getElementById(
    //     `excalidraw__mindmap__outer__toolbar`,
    // )!;
    // toolbar.style.display = "none";
    hiddenToolbar();
    // mindMapFormatInfo = {};
    deleteMindMapControls();
  }
}

document.body.addEventListener("mousedown", mouseDown);

function insertManualBreaks(div: HTMLDivElement) {
  const text = div.innerText;

  const fontSize = parseInt(window.getComputedStyle(div).fontSize);

  const maxWidth =
      div.offsetWidth > 480 ? div.offsetWidth - 30 : div.offsetWidth;

  const font = `${fontSize}px Poppins 微软雅黑, Microsoft YaHei` as FontString;

  const lines = wrapText(text, font, maxWidth);

  return lines;
}

function hasValueInTree(node: {
  data: { text: string };
  children: string | any[];
}) {
  // 如果当前节点的text有值（不为空且不为纯空格），则返回true
  if (node.data.text.trim() !== "") {
    return true;
  }

  // 如果当前节点有子节点，则递归检查每个子节点
  if (node.children && node.children.length > 0) {
    for (const child of node.children) {
      // 如果子节点中有值，则返回true
      if (hasValueInTree(child)) {
        return true;
      }
    }
  }

  // 如果当前节点和所有子节点都没有值，则返回false
  return false;
}

export const DEFAULT_MINDMAP_CONFIG = {
  layout:'logicalStructure',
  fontFamily: 'OpenSans',
  fontSize:32,
  subnodeFontSize:16,
  lineWidth:3,
  lineStyle:'curve'
}

export const getMindmapThemeConfig = (element)=> {
  let config:any = localStorage.getItem(KEY_MINDMAP_STYLE_CONFIG);
  if (config){
    config = (JSON.parse(config));
    if (!config.isDefault){
      config = {...DEFAULT_MINDMAP_CONFIG};
    }
  }else{
    config = {...DEFAULT_MINDMAP_CONFIG};
  }
  if (element?.config){
    config = element.config;
  }else{
    if (element){
      mutateElement(element,{config:config})
    }
  }

  mLayout = config.layout;

  return {
    lineWidth: config.lineWidth,
    lineStyle: config.lineStyle,
    rootLineStartPositionKeepSameInCurve: true,
    // 根节点样式
    root: {
      // 形状
      shape: "rectangle",
      // 背景颜色
      fillColor: "transparent",
      color: getMindmapRootTextColor(),
      fontSize: config.fontSize,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 1.5,
      borderColor: "transparent",
      borderWidth: 0,
      borderDasharray: "none",
      borderRadius: 5,
      textDecoration: "none",
      fontFamily: config.fontFamily,
    },
    // 二级节点样式
    second: {
      // shape: "rectangle",
      // 外边距
      // marginX: 100,
      // marginY: 40,
      // fillColor: "transparent",

      color: getMindmapSecondTextColor(),
      fontSize: config.subnodeFontSize,
      fontFamily: config.fontFamily,
      // fontWeight: "noraml",
      // fontStyle: "normal",
      // lineHeight: 1.5,
      // borderColor: "transparent",
      // fontFamily: "Poppins Helvetica, Segoe UI Emoji",
      // borderColor: "#549688",
      borderWidth: 0,
      fillColor:'transparent',
      // borderDasharray: "none",
      // borderRadius: 5,
      // textDecoration: "none",
    },
    node: {
      color: getMindmapSecondTextColor(),
      fontSize: config.subnodeFontSize,
      fontFamily: config.fontFamily
    },
  }
}

export const createMindMap = (
    pendingmindmapElement: any,
    callBack: any,
    onLinkOpen: any,
    isInsertNew:boolean=true,
    state: Readonly<AppState>
) => {
  const { id } = pendingmindmapElement;
  mapElements[id] = pendingmindmapElement;
  mMindmapcallback = callBack;

  const inner = document.getElementById(
      `excalidraw__mindmap-container__inner${id}`,
  );
  const container = document.getElementById(`excalidraw__mindmap__outer${id}`);
  if (container){
    container.innerHTML = '';
  }

  // Avoid layout "jitter" by only resizing/translating when values actually
  // change meaningfully between renders.
  let lastLayout = { width: 0, height: 0, zoom: 0 };
  // Selecting a node can trigger a render cycle even when the actual layout
  // doesn't change. Skip one translate pass to prevent visible jumps.
  let skipNextLayoutAdjust = false;

  const rootNodeUid = id;//createUid();
  // @ts-ignore
  const mindMap = new MindMap({
    el: container,
    // enableFreeDrag:true,
    data: {
      data: {
        text: "Mind map",
        uid: rootNodeUid,
      },
      children: [],
    },
    theme: isDarkMode()?"dark2":"classic2",
    themeConfig: getMindmapThemeConfig(pendingmindmapElement),
    layout:mLayout,//布局
    initRootNodePosition: ["1%", "10%"],

    rainbowLinesConfig: {
      open: true, // 是否开启彩虹线条
      colorsList: [], // 自定义彩虹线条的颜色列表，如果不设置，会使用默认颜色列表
    },

    customInnerElsAppendTo:document.getElementById('div-drawindex-container'),

    isDisableDrag: true,
    autoMoveWhenMouseInEdgeOnDrag: false,
    mouseScaleCenterUseMousePosition: false,
    defaultInsertSecondLevelNodeText: "Sub node",
    defaultInsertBelowSecondLevelNodeText: "Node",
    openRealtimeRenderOnNodeTextEdit: true,
    isShowCreateChildBtnIcon: false,
    richTextEditFakeInPlace: true,
    // disableMouseWheelZoom:false,
    // mousewheelAction: 'zoom',
    // mousewheelMoveStep: 1,
    customHandleMousewheel: (e) => {//不需要处理这个方法，会导致鼠标在mindmap上面时，第一次滚轮无效。。。。。!!!!!!!!!很多东西无用...
      container!.style.pointerEvents = "none";
      console.log('customHandleMousewheel')
      // return false;
      callBack({
        type:'mouse_wheel',
        event:e
      })
    },
    beforeTextEdit: () => {
      if (APP_WEB){
        return false;
      }
      return new Promise<boolean>((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, 100);
      });
    },
    beforeShortcutRun: (key: string, activeNodeList: any[]) => {
      const hasRootNode = activeNodeList.some((node: any) => {
        return node.isRoot;
      });
      // mindmap复制时候，先加载图片，在插入图片
      if (key === "Control+v") {
        if (!copy.clipboard) {
          return;
        }

        const {
          file: { dataURL: image },
        } = copy.clipboard;
        new Promise<{ width: number; height: number }>((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
            const size = { width: img.width, height: img.height };

            img.remove();
            resolve(size);
          };
          img.onerror = (error) => {
            reject(error);
          };
          img.src = image;
        }).then((size) => {
          const scale = 150 / size.width;
          activeNodeList[0].setImage({
            url: image,
            title: "imageLabel",
            width: 150, // 图片的宽高也不能少
            height: scale * size.height,
            custom: true,
          });
        });
        return true;
      }
      //wai huo....要加这么些--不然会影响别的地方的输入--出不来。。按键会被捕获。-
      // if (["Del", "Backspace"].includes(key) && hasRootNode) {
      //   return true;
      // }

      if (["Control+c", "Del", "Backspace"].includes(key) && hasRootNode) {
        if (key === "Control+c") {
          callBack({
            type: "Control+c",
            id,
          });
        }
        return true;
      }

      return false;
    },
  });

  // const drag = mindMap.drag;

  mindMap.keyCommand.removeShortcut('Backspace',null);
  mindMap.keyCommand.removeShortcut('/',null);
  mindMap.keyCommand.removeShortcut('Control+z',null);

  const rootActive = (rootNode:any)=>{
    rootNode?.active();
    // mindMap.renderer.textEdit.show({ node: rootNode });
    // mindMap.resize();
    rootNode.__isInserting = true;
    mindMap.resize();
    mindMap.render();
    const zoom = callBack({ type: "zoom" });
    // @ts-ignore
    mindMap.view.setScale(zoom);
    mousedownedElementId = id;
    rootNode?.active();
  }

  // 首次进入自动编辑根节点
  if (isInsertNew){
    // console.log('******************isInsertNew---root-active');
    setTimeout(() => {
      const rootNode = mindMap.renderer.root;
      if (rootNode){
        // console.log('******************root-active');
        rootActive(rootNode);
      }else{

      }
    }, 200);
  }

  mindMap.on('data_change_detail',(arrs)=>{
    // console.log('mindmap:',arr)

    for (let i=0;i<arrs.length;i++){
      const arr = arrs[i];
      if (arr.action == 'create' || arr.action == 'delete'){
        // Structural change (node added/removed) — ensure the next
        // node_tree_render_end does a full translateXY instead of skipping.
        (mindMap as any).__excalidrawNodeSelectRender = false;
        clearTimeout((mindMap as any).__excalidrawNodeSelectRenderTimer);
        callBack({
          type: "push_history",
        });
      }
    }
  })

  mindMap.on(
      "rich_text_selection_change",
      (hasRange: any, rect: any, formatInfo: any) => {
        const toolbar = document.getElementById(
            `excalidraw__mindmap__outer__toolbar`,
        )!;
        if (hasRange) {
          const { left, top } = rect;
          toolbar.style.display = "block";
          toolbar.style.left = `${left - 30}px`;
          toolbar.style.top = `${top - 50}px`;

          if (formatInfo) {
            mindMapFormatInfo = {...formatInfo, id };
          }
        }else {
          // const toolbar = document.getElementById(
          //     `excalidraw__mindmap__outer__toolbar`,
          // )!;
          // toolbar.style.display = "none";
          hiddenToolbar();
          global.g_isKeepMindmapToolbarShow = false;
          // mindMapFormatInfo = {};

          if (formatInfo) {
            mindMapFormatInfo = {...mindMapFormatInfo, ...formatInfo, id };
          }
        }

        // hasRange（是否存在选区）
        // rectInfo（选区的尺寸和位置信息）
        // formatInfo（选区的文本格式化信息）
      },
  );

  mindMap.on('node_dragging',(data)=>{
    hiddenToolbar();
  })


  mindMap.on("node_text_edit_change", async (data: any) => {
    mCurrentMindmapData = data;
    // mindMapUid_Text.set(data?.node?.uid,data?.text);

    // mutateElement(pendingmindmapElement,{data: mindMapData})
    //不在这里更新，在render-end那里更新
    // mindMapId_Data.set(pendingmindmapElement.id,mindMapData)
  });

  // mindMap.on("back_forward", (index: any, len: any) => {
  //   // console.log(index, len);
  //   callBack({
  //     type: "back_forward",
  //     index,
  //     element: pendingmindmapElement,
  //   });
  // });

  mindMap.on("hide_text_edit", (textEditNode: any, activeNodeList: any[]) => {
    g_isEditMindmap = false;
    const node = activeNodeList[0];

    const zoom = callBack({ type: "zoom" });
    addMindMapControls(node, mindMap, addIcon, OFFSET, zoom);

    callBack({
      type:'hide_text_edit'
    })

    if (node.isRoot) {
      const mindMapData = mindMap.getData(false);
      //如果没有文字的话遍历子节点是否有文字
      if (!hasValueInTree(mindMapData)) {
        callBack({
          type: "destory",
          mindMap,
          id,
        });
      }
    }
  });

  // mindMap.on("hide_text_edit", (textEditNode: any, activeNodeList: any[]) => {
  //   // console.log('***hide_text_edit***')
  //   g_isEnterMindmap = true;
  //   setTimeout(()=>{
  //     g_isEnterMindmap = false;
  //   },1000);
  //   g_isEditMindmap = false;
  //   if(activeNodeList.length == 0)return;
  //   const node = activeNodeList[0];
  //   const text = insertManualBreaks(textEditNode);
  //   node?.setText(text, false, true);
  //
  //   const zoom = callBack({ type: "zoom" });
  //   addMindMapControls(node, mindMap, addIcon, OFFSET,zoom);
  //
  //   if (node.isRoot) {
  //     const mindMapData = mindMap.getData(false);
  //     //如果没有文字的话遍历子节点是否有文字
  //     if (!hasValueInTree(mindMapData)) {
  //       callBack({
  //         type: "destory",
  //         mindMap,
  //         id,
  //       });
  //     }
  //   }
  // });

  mindMap.on("before_show_text_edit", () => {
    g_isEditMindmap = true;
    //这里要取消别的输入焦点选中...
    callBack({
      type:'reset_selected_element',
      mindMap,
      id,
    })
    // hiddenToolbar();

    // const toolbar = document.getElementById(
    //     `excalidraw__mindmap__outer__toolbar`,
    // )!;
    // toolbar.style.display = "none";

    // if (observeEditor) {
    //   return;
    // }
    // setTimeout(() => {
    //   // @ts-ignore
    //   mindMap.richText.quill.container.addEventListener("paste", (e: any) => {
    //     setTimeout(() => {
    //       // @ts-ignore
    //       mindMap.richText.updateTextEditNode({
    //         // @ts-ignore
    //         node: mindMap.richText.node,
    //         isFromScale: true,
    //       });
    //     }, 10);
    //   });
    //   observeEditor = true;
    // }, 0);
  });

  /*
  mindMap.on("before_show_text_edit", () => {
    g_isEditMindmap = true;
    if (observeEditor) {
      return;
    }
    const container = document.getElementsByClassName(
        "excalidraw__mindmap-container",
    )[0] as HTMLDivElement;

    const transform = container.style.transform;
    const match = transform.match(scaleRegex);
    const scaleValue = match ? Number(parseFloat(match[1]).toFixed(2)) : 1;

    const nodeRect = mindMap.draw.node.getBoundingClientRect();

    const svgParentElement = mindMap.draw.node.parentElement;
    const containerRect = svgParentElement.getBoundingClientRect();

    const deltaY = nodeRect.y - containerRect.y;
    mindMap.view.translateY(-(deltaY / scaleValue) + 10);

    const offsetX = containerRect.x - nodeRect.x;
    mindMap.view.translateX(offsetX + 10);

    setTimeout(()=>{
      const editableDivs = Array.from(
          document.body.querySelectorAll("div[contenteditable=true]"),
      );
      const lastNode = editableDivs.reverse()[0] as HTMLElement;
      if (
          lastNode &&
          lastNode.tagName.toLowerCase() === "div" &&
          lastNode.contentEditable === "true"
      ) {
        if (global.g_isPresentMode){
          // lastNode.contentEditable = 'false';
          // lastNode.innerText = '';
          lastNode.style.opacity = '0';
          return;
        }

        lastNode.style.opacity = '1';
        lastNode.style.background = isDarkMode()?"#2c2c2c":"#ffffff";

        if (scaleValue < 1) {
          const currentEditNode = mindMap.renderer.textEdit.getCurrentEditNode();
          const rect = currentEditNode.group.node.getBoundingClientRect();
          setTimeout(() => {
            lastNode.style.left = `${rect.x + rect.width / 10}px`;
            lastNode.style.top = `${rect.y + rect.height / 10}px`;
            lastNode.style.fontSize = `${16 * scaleValue}px`;
          }, 0);
        }
      }
    },10)

  });

   */


  mindMap.on("before_show_text_edit", () => {
    const toolbar = document.getElementById(
        `excalidraw__mindmap__outer__toolbar`,
    )!;
    toolbar.style.display = "none";
  });


  mindMap.on("node_tree_render_end", async () => {
    // Selection-only render (node click without structural change): skip
    // translateXY to prevent the selection highlight from shifting the mindmap.
    // The flag is set in node_mousedown for non-expand-btn clicks.
    if ((mindMap as any).__excalidrawNodeSelectRender) {
      (mindMap as any).__excalidrawNodeSelectRender = false;
      clearTimeout((mindMap as any).__excalidrawNodeSelectRenderTimer);
      return;
    }

    const zoom = callBack({ type: "zoom" });
    // 获取节点区域信息
    const gElement = mindMap.draw.node;
    // The active-node "+" controls are SVG elements and would affect the
    // bounding box. Temporarily hide them while measuring to avoid layout
    // jitter when selecting nodes.
    const controls = [
      beforeLeftNodeElement,
      beforeRightNodeElement,
      beforeBottomNodeElement,
    ].filter(Boolean);
    const prevVis: (string | null)[] = [];
    try {
      controls.forEach((el: any, idx: number) => {
        prevVis[idx] = el.getAttribute?.("visibility") ?? null;
        el.setAttribute?.("visibility", "hidden");
      });
    } catch {}

    const gRect = gElement.getBoundingClientRect();

    try {
      controls.forEach((el: any, idx: number) => {
        const vis = prevVis[idx];
        if (vis == null) {
          el.removeAttribute?.("visibility");
        } else {
          el.setAttribute?.("visibility", vis);
        }
      });
    } catch {}

    const newWidth = gRect.width + 60 * zoom;
    const newHeight = gRect.height + 100 * zoom;

    if (APP_WEB){
      if (Math.abs(pendingmindmapElement.width - newWidth) <= 2 && Math.abs(pendingmindmapElement.height - newHeight) <= 2){
        return;
      }
    }

    // 设置内部元素的新宽度和高度
    container!.style.width = `${newWidth}px`;
    container!.style.height = `${newHeight}px`;
    // 调整svg区域并render节点
    // @ts-ignore
    // mindMap.resize();
    const svgElement = mindMap.svg.node;
    const svgRect = svgElement.getBoundingClientRect();
    // g移动到svg区域内
    const offset = 3 * zoom;
    const deltaX = svgRect.x - gRect.x + offset;
    const deltaY = svgRect.y - gRect.y + 50 * zoom;

    // If this render was triggered only by selection changes, avoid translating
    // the whole view to prevent visible "jitter". Still allow resize above so
    // new nodes won't be clipped.
    const shouldTranslate = !(
        skipNextLayoutAdjust && zoom === lastLayout.zoom
    );
    skipNextLayoutAdjust = false;
    if (
        shouldTranslate &&
        (Math.abs(deltaX) > 0.5 || Math.abs(deltaY) > 0.5)
    ) {
      mindMap.view.translateXY(deltaX, deltaY);
    }

    // // 获取节点区域信息
    // const nodeRect = mindMap.draw.node.getBoundingClientRect();
    // const newWidth = nodeRect.width + 60;
    // const newHeight = nodeRect.height + 100;
    // // 设置内部元素的新宽度和高度
    // container!.style.width = `${newWidth}px`;
    // container!.style.height = `${newHeight}px`;
    //
    // const svgElement = mindMap.svg.node;
    // const svgElementRect = svgElement.getBoundingClientRect();
    // // g移动到svg区域内
    // const offset = 3;
    // const deltaX = svgElementRect.x - nodeRect.x + offset;
    // const deltaY = svgElementRect.y - nodeRect.y + 50;
    // mindMap.view.translateXY(deltaX, deltaY);

    // 更新待处理的思维导图元素renderMindMap的数据和尺寸
    let data = mindMap.getData(false);

    if (mCurrentMindmapData){
      await recursionMindmapData(data, (node: any) => {
        if (node.uid == mCurrentMindmapData?.node?.uid){
          node.text = mCurrentMindmapData.text;
        }
      })
    }

    // const zoom = callBack({ type: "zoom" });
    // @ts-ignore
    mindMap.richText.updateTextEditNode();
    // const configgggggggggg = pendingmindmapElement.config;
    // pendingmindmapElement = callBack({type:'get_real_element',element:pendingmindmapElement})
    // pendingmindmapElement.config = configgggggggggg;

    mutateElement(pendingmindmapElement, {
      width: newWidth / zoom,
      height: newHeight / zoom,
      data: data,
    });

    //这里，延迟调整下框框才有效。时间不能太短，也不能太长。----  不然双击编辑切换有问题
    setTimeout(()=>{
      //一定从获取获取下这个值，不知道哪里有更改  mutateElement 这个东西直接改不动数据。改不了。。。改不了改不了改不了改不了改不了改不了改不了
      data = mindMap.getData(false);
      if (window.forceUpdateMindmap){
        window.forceUpdateMindmap({data:{element:pendingmindmapElement,width:newWidth / zoom,height:newHeight / zoom,data}})
      }
    },320)

    updateMindmapLinkIcon();

    if (mapMindResizeCount[rootNodeUid] > 100){
      mapMindResizeCount[rootNodeUid] = 0;
      return;
    }
    // 调整svg区域并render节点
    // @ts-ignore
    try{
      console.log('***********render-end----');
      mindMap.resize();
    }catch (e) {
      console.log(e);
    }
    mapMindResizeCount[rootNodeUid] =  (mapMindResizeCount[rootNodeUid] || 0) + 1;
  });

  /*
  mindMap.on("node_tree_render_end", () => {
    const container = document.getElementsByClassName(
        "excalidraw__mindmap-container",
    )[0] as HTMLDivElement;

    const transform = container.style.transform;
    const match = transform.match(scaleRegex);
    const scaleValue = match ? Number(parseFloat(match[1]).toFixed(2)) : 1;

    const nodeRect = mindMap.draw.node.getBoundingClientRect();

    const svgParentElement = mindMap.draw.node.parentElement;
    const containerRect = svgParentElement.getBoundingClientRect();

    const newWidth = (nodeRect.width + 60) / scaleValue;
    const newHeight = (nodeRect.height + 50) / scaleValue;

    inner!.style.width = `${newWidth}px`;
    inner!.style.height = `${newHeight}px`;

    const deltaY = nodeRect.y - containerRect.y;
    mindMap.view.translateY(-(deltaY / scaleValue) + 10);
    mindMap.resize();

    const svgWidth = svgParentElement.getAttribute("width");
    const svgHeight = svgParentElement.getAttribute("height");

    svgParentElement.setAttribute("width", svgWidth / scaleValue);
    svgParentElement.setAttribute("height", svgHeight / scaleValue);

    const offsetX = containerRect.x - nodeRect.x;
    mindMap.view.translateX(offsetX + 10);
    const data = cloneDeep(mindMap.getData(false));

    mutateElement(pendingmindmapElement, {
      width: newWidth,
      height: newHeight,
      data,
    });
    setTimeout(()=>{
      postMessage(EVENT_FORCE_UPDATE_MINDMAP, {element:pendingmindmapElement,width:newWidth,height:newHeight,data})
    },10)
  });

   */

  mindMap.on("mousedown", (event,node) => {
    mousedownedElementId = id;
    elMousedown = true;
    callBack({
      type: "mousedown",
      event,
    });

    if (activeNode?.node?.isRoot){
      if (activeNode?.node?.uid != node.mindMap.renderer.root.uid){
        hiddenToolbar();
      }
    }else{
      hiddenToolbar();
    }

    // When no node is currently active, we sometimes want to "click-through" the
    // mindmap container so Excalidraw can select/drag the mindmap element (e.g.
    // when dragging from blank area).
    //
    // However, if we set `pointerEvents = "none"` immediately on mousedown, we
    // can accidentally prevent `simple-mind-map` from receiving the subsequent
    // mouseup/click that activates a node — this becomes especially noticeable
    // at small canvas zoom levels, where node hit areas are tiny and event order
    // can differ.
    //
    // So we defer the click-through decision to the next tick, after
    // `node_mousedown` had a chance to run and set `mousedownedNode`.
    const isLikelyNodeTarget = (() => {
      try {
        const el = event?.target instanceof Element ? (event.target as Element) : null;
        if (!el) return false;
        // Controls/interactive elements inside mindmap should never click-through.
        if (el.closest?.(".smm-expand-btn")) return true;
        if (el.closest?.('[data-mindmap-control="true"]')) return true;
        if (el.closest?.("a")) return true;
        // Common node render primitives (including richtext foreignObject content).
        const tag = (el as any).tagName?.toLowerCase?.();
        if (
            tag &&
            ["rect", "path", "circle", "tspan", "text", "image", "foreignobject"].includes(tag)
        ) {
          return true;
        }
        // Rich-text editor wrappers.
        if (
            el.closest?.(".smm-richtext-node-wrap") ||
            el.closest?.(".smm-richtext-node-edit-wrap")
        ) {
          return true;
        }
      } catch {}
      return false;
    })();

    if (
        !isLikelyNodeTarget &&
        !mousedownedNode &&
        !mindMap.renderer.textEdit.getCurrentEditNode() &&
        mindMap.renderer.activeNodeList.length === 0
    ) {
      isBlankAreaDrag = true;
      startX = event.clientX;
      startY = event.clientY;
      startTime = new Date().getTime();
      isDragging = false;
    }

    //屏蔽别的mindmap的事件响应
    for (const element of mindMapCache) {
      if (node.mindMap.element.id == element[0])continue;
      const dom = document.getElementById(
          `excalidraw__mindmap__outer${element[0]}`,
      )!;
      if (dom){
        dom.style.pointerEvents = "none";
      }
    }

    mMindmapcallback({
      type: "mousedown",
      node,
      event,
    });
  });

  mindMap.on("node_contextmenu", (event: any, node: any) => {
    if (global.g_isPresentMode)return;
    mMindmapcallback({
      type: "node_contextmenu",
      node,
      event,
    });
  });
  mindMap.on("mousemove", (event: any,node) => {
    //如果全部选中了那么mmousedownedNode 就是根节点
    if ((!mousedownedNode && !isBlankAreaDrag) || !mousedownedElementId) {
      return;
    }
    if (global.g_isPresentMode)return;

    updateNodesToolbarPosition(node.mindMap);
    pointerNoneThis(node.mindMap);

    // 判断是否发生了拖动
    if (!isDragging) {
      const moveX = event.clientX - startX;
      const moveY = event.clientY - startY;
      const moveTime = new Date().getTime() - startTime;
      // 如果移动距离超过5像素或移动时间超过100毫秒，则认为是拖动
      if (moveX * moveX + moveY * moveY > 25 || moveTime > 100) {
        isDragging = true;
        // hiddenToolbar();
        //隐藏外部的那个菜单.
        if (window.hiddenCanvasFloatMenu){
          window.hiddenCanvasFloatMenu();
        }

        // Drag the whole mindmap when pressing root node OR blank area.
        if (mousedownedNode?.isRoot || isBlankAreaDrag) {
          // const currentMindmapElement = Scene.getScene(
          //     pendingmindmapElement,
          // )?.getElement(mousedownedElementId);
          const currentMindmapElement = mapElements[mousedownedElementId];
          container!.style.pointerEvents = "none";
          mMindmapcallback({
            type: "mousemove",
            element: currentMindmapElement,
            event,
          });
        }
      }
    }
  });


  mindMap.on("node_mousedown", async (node: any, event: any) => {
    mousedownedNode = node;
    isBlankAreaDrag = false;
    startX = event.clientX;
    startY = event.clientY;
    startTime = new Date().getTime();
    isDragging = false;
    global.g_mousedownNode = node;

    // If the user clicked the expand/collapse control, the mindmap structure
    // will change and the DOM content size will change. Mark data dirty so our
    // `node_tree_render_end` handler will re-measure + resize the outer container
    // instead of early-returning as a selection-only render (which would cause
    // clipped content after expanding).
    try {
      const targetEl =
          event?.target instanceof Element ? (event.target as Element) : null;
      if (targetEl?.closest?.(".smm-expand-btn")) {
        (mindMap as any).__excalidrawDataDirty = true;
      } else {
        // Selection-only click: flag the next node_tree_render_end to skip
        // translateXY so the selection highlight doesn't shift the mindmap
        (mindMap as any).__excalidrawNodeSelectRender = true;
        clearTimeout((mindMap as any).__excalidrawNodeSelectRenderTimer);
        (mindMap as any).__excalidrawNodeSelectRenderTimer = setTimeout(() => {
          (mindMap as any).__excalidrawNodeSelectRender = false;
        }, 500);
      }
    } catch {}

    mMindmapcallback({
      type:'node_mousedown',
      element: pendingmindmapElement,
    })

    // const toolbar = document.getElementById(
    //     `excalidraw__mindmap__outer__toolbar`,
    // )!;
    // toolbar.style.display = "none";
    // hiddenToolbar();

    const target = event.target;
    const link = target.closest("a");

    if (link) {
      const href = link.getAttribute("href");
      // link.setAttribute('href',"javascript:void(0)");
      link.onclick = function (e){
        return false;
      }
      onLinkOpen(
          {
            mindmap:true,
            link: normalizeLink(href),
          },
          event,
      );
      mousedownedNode = null;
      global.g_mousedownNode = null;

      //点击链接后的退格键不能用问题？？？？为什么有这种事情...
      mousedownedElementId = node.mindMap.el.id.replace('excalidraw__mindmap__outer','');
      const currentMindmap = mindMapCache.get(mousedownedElementId);
      if (currentMindmap) {
        const activeNodes = activeNode?.node;
        const currentEditNode =
            currentMindmap.renderer.textEdit.getCurrentEditNode();
        if (currentEditNode) {
          currentMindmap.renderer.textEdit.hideEditTextBox();
          setTimeout(() => {
            currentMindmap.keyCommand.pause();
          }, 0);
        }
        activeNodes?.deactivate();
      }

      mindMapCache.forEach((value, key, map)=>{
        value.renderer.textEdit.hideEditTextBox();
        value.keyCommand.pause();
      })
    }

    //+和工具栏
    // const zoom = callBack({ type: "zoom" });
    // addMindMapControls(node, mindMap, isDarkMode()?addIconWhite:addIcon, OFFSET,zoom);
    if (!event.target.classList.contains('mindmap-add-node')){
      renderNodesToolBar(
          [node].filter((item) => !!item),
          id,
      );
    }

    // activeNode = { element: pendingmindmapElement, node };
    //
    // mMindmapcallback({
    //   type: "node_active",
    //   node,
    //   element: pendingmindmapElement,
    // });
    // beforeActiveNode = node;
    //end

    if (global.g_isPresentMode){
      const target = event.target;
      const href = target.getAttribute("href");
      if (href){
        if (hasNodeExtra(node)){
          const extra = node.getData().extra;
          if (extra.type == 'pdf'){
            if (APP_WEB){
              const szUrl = getShareFileUrl(global.g_currentSharedProjectId,extra.fileName);
              postMessage(EVENT_PDF_ON_SLIDER_RIGHT,{pdfPath:szUrl,fileId:extra.id,fileName:extra.showName??getFileName(extra.fileName),pdfFileName:extra.fileName});
            }else{
              let szFilePath = localStorage.getItem(KEY_FILE_DIR) + extra.fileName;
              if (checkIfAbsolute(extra.fileName)){
                szFilePath = extra.fileName;
              }
              ipcInvoke('read-file-absolute-path',{filePath:szFilePath}).then(res=> {
                const blob = new Blob([res]);
                const url = URL.createObjectURL(blob);
                postMessage(EVENT_PDF_ON_SLIDER_RIGHT,{pdfPath:url,fileId:extra.id,fileName:extra.showName??getFileName(extra.fileName),pdfFileName:extra.fileName});
              })
            }

          }else if (extra.type == 'card'){
            if (!extra.content){
              const card = await window.methodGetNoteById(extra.id);
              extra.showName = card.name;
              extra.content = card.doc;
            }
            const newData = {
              id:extra.id,
              name:extra.showName,
              doc:extra.content
            }
            postMessage(EVENT_NOTE_ON_SLIDER_RIGHT, {data:newData,scrollRate:0});
          }
        }else{
          emitter.emit("imagePreview", { visible: true, href });
        }
      }
    }
  });
  mindMap.on("mouseup", () => {
    if (isDragging) {
      // @ts-ignore
      mindMap.render();
    }

    isDragging = false;
    mousedownedNode = null;
    isBlankAreaDrag = false;
    global.g_mousedownNode = null;

    //正常使用别的mindmap的事件响应
    if (isMindmapElement(global.g_hitElement)){
      for (const element of mindMapCache) {
        const dom = document.getElementById(
            `excalidraw__mindmap__outer${element[0]}`,
        )!;
        if (dom){
          // dom.style.pointerEvents = "all";
        }
      }
    }

    mMindmapcallback({
      type:'mouseup',
      element:pendingmindmapElement
    })
  });

  mindMap.on("node_img_dblclick", async (node: any, event: any) => {
    if (global.g_isPresentMode)return;
    //清除选中的...
    mindMap.execCommand('CLEAR_ACTIVE_NODE');
    hiddenToolbar();

    event.preventDefault();
    event.stopPropagation();
    if (hasNodeExtra(node)){
      const extra = node.getData().extra;
      if (extra.type == 'pdf'){
        const szFilePath = (extra.isAbsolutePath?'':localStorage.getItem(KEY_FILE_DIR)) + extra.fileName;
        ipcInvoke('read-file-absolute-path',{filePath:szFilePath}).then(res=> {
          const blob = new Blob([res]);
          const url = URL.createObjectURL(blob);
          postMessage(EVENT_PDF_ON_SLIDER_RIGHT,{
            pdfPath:url,
            fileId:extra.id,
            fileName:extra.showName??getFileName(extra.fileName),
            pdfFileName:extra.fileName,
            breadcrumb:createBreadcrumb('library',extra.name??getFileName(extra.fileName))});
        })
      }else if (extra.type == 'card'){
        const card = await window.methodGetNoteById(extra.id);
        if (card){
          extra.showName = card.name;
          extra.content = card.doc;
        }

        const newData = {
          id:extra.id,
          name:extra.showName,
          doc:extra.content
        }
        postMessage(EVENT_NOTE_ON_SLIDER_RIGHT, {data:newData,scrollRate:0});
      }
    }else{
      const target = event.target;
      const href = target.getAttribute("href");
      emitter.emit("imagePreview", { visible: true, href });
    }
  });
  mindMap.on("node_attachmentClick", (node: any, event: any) => {
    event.preventDefault();
    event.stopPropagation();
    // emitter.emit("imagePreview", {
    //   visible: true,
    //   href: node._customInfo.href,
    // });
    let szHref = node.nodeData.data.attachmentUrl.url;
    onLinkOpen(
        {
          mindmap:true,
          link: normalizeLink(szHref),
        },
        event,
    );
  });
  mindMap.on('node_img_mouseenter',(node,event)=>{
    if (global.g_isPresentMode){
      mindMap.nodeImgAdjust.hideHandleEl();
    }else{
      // mindMap.nodeImgAdjust.showHandleEl();
    }
  })
  mindMap.on('node_img_mousemove',(node,event)=>{
    if (global.g_isPresentMode){
      mindMap.nodeImgAdjust.hideHandleEl();
    }else{
      // mindMap.nodeImgAdjust.showHandleEl();
    }
  })

  mindMap.on("node_active", (node1: any) => {
    // console.log('node_active********')
    if (global.g_isPresentMode) {
      mindMapCache.forEach((value, key, map)=>{
        value.renderer.clearActiveNode();
      })
      return
    };

    //清空当前焦点
    if (document.activeElement){
      document.activeElement.blur();
    }

    if (mindMap.renderer.activeNodeList?.length > 1) {
      deleteMindMapControls();
      // const toolbar = document.getElementById(
      //     `excalidraw__mindmap__outer__toolbar`,
      // )!;
      // toolbar.style.display = "none";
      hiddenToolbar();
      return;
    }

    mindMap.keyCommand.recovery();
    const node = node1 || mindMap.renderer.activeNodeList[0];
    // When the render is triggered by selection only, skip translating once to
    // prevent jitter. When inserting new nodes, we must not skip because layout
    // changes need to be fully applied (otherwise nodes may be clipped).
    skipNextLayoutAdjust = !!node && !(node as any).__isInserting;
    emitter.emit("node_active", { mindMap, node });

    if (beforeActiveNode && node && beforeActiveNode.uid === node.uid) {
      return;
    }
    const zoom = callBack({ type: "zoom" });
    addMindMapControls(node, mindMap, isDarkMode()?addIconWhite:addIcon, OFFSET,zoom);
    renderNodesToolBar(
        [node].filter((item) => !!item),
        id,
    );
    activeNode = { element: pendingmindmapElement, node };

    mMindmapcallback({
      type: "node_active",
      node,
      element: pendingmindmapElement,
    });
    beforeActiveNode = node;
  });

  mindMap.on(
      "node_dragend",
      ({ overlapNodeUid }: { overlapNodeUid?: string }) => {
        if (overlapNodeUid) {
          return;
        }
        // @ts-ignore
        const drag = mindMap.drag;
        const { autoMoveTimer } = drag?.autoMove;
        if (autoMoveTimer){
          drag.autoMove.clearAutoMoveTimer(autoMoveTimer);
        }
        // @ts-ignore
        mindMap.render();
      },
  );

  // @ts-ignore
  mindMap.on("node_text_edit_change", ({ node, text, delta }) => {
    if (!delta) {
      return;
    }
    const insertOpsItem = delta.ops.find((item: any) => item.insert);
    if (insertOpsItem) {
      const insert = insertOpsItem.insert;
      if (insert === "@") {
        mindMap.renderer.textEdit.hideEditTextBox();
        callBack({
          type: "add_link",
          delta,
        });
      }
    }
  });

  // 单个按键
  mindMap.keyCommand.removeShortcut('Enter',null);

  mindMap.element = pendingmindmapElement;
  mindMapCache.set(id, mindMap);

  return mindMap;
};

function hasNodeExtra(node:any){
  if (!node)return false;
  return node.getData().extra && Object.keys(node.getData().extra).length > 0;
}

window.onRemoveImage = (mindMap,node,event)=> {
  const extra = node.getData().extra;
  if (extra.type == 'pdf') {
    postMessage(EVENT_MINDMAP_REMOVE_ATTACH, {mindMap: mindMap, node: node, command: 'SET_NODE_IMAGE'});
    return;
  }

  window.showMessageBox(t("Tips"), t("DeleteThisImageFromMindmap"), t("Cancel"), t("Delete"), null, () => {
    if (hasNodeExtra(node)) {
      postMessage(EVENT_MINDMAP_REMOVE_ATTACH, {mindMap: mindMap, node: node, command: 'SET_NODE_IMAGE'})
    } else {
      mindMap.execCommand('SET_NODE_IMAGE', node, {url: null})
    }
  });
}
